<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Números de serie</h1>
          <p class="view-header__subtitle">Administrá los números de serie asociados al producto.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <!-- FILTROS -->
        <div class="filters-panel">
          <div class="filters-panel__section">
            <div class="filters-panel__section-title">
              <i class="bi bi-search"></i>
              Buscador
            </div>
            <div class="filters-panel__row">
              <div class="filters-panel__field">
                <input
                  v-model="doSearch"
                  type="search"
                  class="form-control"
                  placeholder="Buscar número de serie..."
                >
              </div>
            </div>
          </div>
        </div>

        <!-- TABLA -->
        <div class="data-table">
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="opts"
            :selectCheckbox="0"
            container-class-name="table-responsive"
            class-name="table mb-0"
            @edit="getSerialNumber"
            @delete="deleteSerialNumber"
            @reloaded="tableReloaded"
          />
        </div>
      </div>

      <!-- FORMULARIO -->
      <div class="col-md-4">
        <EditSerialNumber
          :serialNumberId="serialNumberId"
          :productId="productId"
          v-on:saved="editSaved"
          v-on:saving="editSaving"
          v-on:loaded="editLoaded"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import EditSerialNumber from './EditSerialNumber.vue';
let serialNumbersApiRoute = process.env.VUE_APP_BASE_URL+"/api/serialnumbers/";

export default {
  props: ['productId'],
  components: {
    VdtnetTable,EditSerialNumber
  },
  data: function () {
    return {
      
      doSearch: '',
      isLoading: false,
      opts: {
        ajax: {
          url: serialNumbersApiRoute + "list",
          type: "GET",
          headers: {Authorization: "Bearer " + localStorage.getItem("token")},
          data:  {
            product_id : this.productId
          }
        },
        autoWidth: false,
      },
      fields: {
        code: {label: "Numero de serie", searchable: true},
        product_name: {visible: false, searchable: true},
        provider_name: {label: "Proveedor", searchable: true},
        client_name: {label: "Cliente", searchable: true},
        id: {visible: false},
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "80px",
          defaultContent:
              '<div class="table-action-group">' +
              '<button data-action="edit" type="button" class="table-action-btn" title="Editar"><i class="bi bi-pencil"></i></button>' +
              '<button data-action="delete" type="button" class="table-action-btn" title="Eliminar"><i class="bi bi-trash"></i></button>' +
              "</div>",
        },
      },
      serialNumberId: null,
    };
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch)
      }
      if (newValue === '' && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch)
      }
    },
  },
  methods: {
    emptySerialNumber() { 
      return {
        id: null,
        code: "",
        product_id: this.productId,
        provider_id : null
        }
      },
    getSerialNumber(data) {
      if(this.serialNumberId == data.id) return;
      this.serialNumberId = data.id;
      this.isLoading = true
    },
    async deleteSerialNumber(data) {
      const ok = await this.$confirm(
        "Esta seguro que desea borrar?",
        { title: 'Eliminar numero de serie', okText: 'Eliminar', variant: 'danger' }
      );
      if (ok) {
        this.isLoading = true
        this.$http
            .post(serialNumbersApiRoute + "delete", {id: data.id})
            .then((response) => {
              
              if (response.data.code == 200) {
                this.$refs.table.reload();
                this.serialNumber = this.emptySerialNumber();
              }
            });
      }
    },
    tableReloaded(){
       this.isLoading = false;
    },
    editSaved(){
      this.serialNumberId = null;
      this.$refs.table.reload();
    },
    editSaving(){
      this.isLoading = true
    },
    editLoaded(){
      this.isLoading = false
    }
  },
};
</script>

